import React, { useRef, useState } from "react"

import api from "@api"
import { useAppContext } from "@components/AppContext"

import PlaidConnect from "./PlaidConnect"
import ConfirmModal from "./ConfirmModal"

const connectSourceOperation = api.get("transactions/ConnectSource")
const readSourceLinkOperation = api.get("transactions/ReadSourceLink")


const PlaidModal = ({
  onSuccess: onSuccessCustom,
  modal,
  onClose,
  investment,
  customerId,
}) => {
  const confirmModal = useRef({})

  const [ linkToken, setLinkToken ] = useState()

  const {
    showErrorMessage,
    authenticatedRequest,
    addIdentityCustomerSource,
  } = useAppContext()

  const createLinkToken = () => {
    setLinkToken(null)
    return authenticatedRequest(readSourceLinkOperation.id)
      .then(({ data }) => setLinkToken(data.linkToken))
  }

  modal.current.open = async (setLoading) => {
    if (investment) {
      return confirmModal.current.open()
    }

    setLoading(true)
    await createLinkToken()
    setLoading(false)
  }

  const onSuccess = sourceToken => {
    const parameters = {
      mutation: {
        sourceToken,
        customerId
      }
    }

    const expectedErrors = ['UnprocessibleConditionError']

    return authenticatedRequest(connectSourceOperation.id, parameters, expectedErrors)
      .then(({ data: source }) => {
        addIdentityCustomerSource(customerId, source)
        return onSuccessCustom(source.id, source)
      })
      .catch(exception => {
        const { isExpected, originalError } = exception

        if (isExpected) {
          showErrorMessage(originalError.message)
        }

        throw exception
      })
      .finally(() => onClose())
  }

  const confirmModalProps = {
    onOk: createLinkToken,
    modal: confirmModal,
    investment,
  }

  return (
    <>
      {
        linkToken && (
          <PlaidConnect
            token={linkToken}
            onExit={onClose}
            onSuccess={onSuccess}
          />
        )
      }

      {
        investment && (
          <ConfirmModal
            {...confirmModalProps}
          />
        )
      }
    </>
  )
}

export default PlaidModal
